/* IC pre-order product: variant picker, price, countdown, pre-order window, sticky bar */
if (!customElements.get('ich-preorder')) {
  class IchPreorder extends HTMLElement {
    connectedCallback() {
      const $ = (sel) => this.querySelector(sel);
      this.variants = JSON.parse($('[data-po-variants]').textContent);
      this.form = $('form');
      this.idInput = $('[data-po-variant-id]');
      this.property = $('[data-po-property]');
      this.submit = $('[data-po-submit]');
      this.submitLabel = $('[data-po-submit-label]');
      this.submitSub = $('[data-po-submit-sub]');
      this.barBtn = $('[data-po-bar-btn]');
      this.bar = $('[data-po-bar]');
      this.groups = [...this.querySelectorAll('[data-po-option]')];
      this.end = this.dataset.end ? new Date(this.dataset.end) : null;
      if (this.end && isNaN(this.end)) this.end = null;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: this.dataset.currency || 'GBP',
      });

      this.groups.forEach((g) => g.addEventListener('change', () => this.onOptionChange(g)));
      this.querySelectorAll('[data-po-qty]').forEach((b) =>
        b.addEventListener('click', () => {
          const input = this.form.querySelector('[name="quantity"]');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.poQty, 10));
        })
      );
      this.form.addEventListener('submit', (e) => {
        if (this.submit.disabled) e.preventDefault();
      });

      this.initGallery();
      this.initBar();
      this.current = this.variants.find((v) => String(v.id) === this.idInput.value) || this.variants[0];
      this.syncOptions(null);
      this.tick();
      if (this.end) this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer && this.observer.disconnect();
      this.resizeObs && this.resizeObs.disconnect();
    }

    /* ---------- pre-order window ---------- */
    isOpen() {
      return !this.end || Date.now() < this.end.getTime();
    }

    tick() {
      const open = this.isOpen();
      const box = this.querySelector('[data-po-countdown]');
      if (box && this.end) {
        const timer = this.querySelector('[data-po-timer]');
        if (open) {
          let t = Math.max(0, Math.floor((this.end.getTime() - Date.now()) / 1000));
          const d = Math.floor(t / 86400); t -= d * 86400;
          const h = Math.floor(t / 3600); t -= h * 3600;
          const m = Math.floor(t / 60); const s = t - m * 60;
          const pad = (n) => String(n).padStart(2, '0');
          this.querySelector('[data-po-d]').textContent = pad(d);
          this.querySelector('[data-po-h]').textContent = pad(h);
          this.querySelector('[data-po-m]').textContent = pad(m);
          this.querySelector('[data-po-s]').textContent = pad(s);
        } else if (!box.hasAttribute('data-closed')) {
          box.setAttribute('data-closed', '');
          timer.hidden = true;
          const title = this.querySelector('[data-po-countdown-title]');
          if (title) title.textContent = title.dataset.closed || 'Pre-order has now closed';
        }
      }
      if (open !== this.lastOpen) {
        this.lastOpen = open;
        this.updateButton();
        if (!open) clearInterval(this.timer);
      }
    }

    /* ---------- variants ---------- */
    selected() {
      return this.groups.map((g) => {
        const c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    onOptionChange(group) {
      this.syncOptions(parseInt(group.dataset.poOption, 10));
    }

    /* Keep later options valid for earlier choices, and hide an option that only has one
       possible value (e.g. "Ring: N/A" when Earrings is chosen). */
    syncOptions(changedIndex) {
      const sel = this.selected();
      this.groups.forEach((g, i) => {
        const earlier = sel.slice(0, i);
        const possible = new Set(
          this.variants
            .filter((v) => earlier.every((val, j) => val === null || v.options[j] === val))
            .map((v) => v.options[i])
        );
        const inputs = [...g.querySelectorAll('input')];
        inputs.forEach((inp) => {
          const ok = possible.has(inp.value);
          inp.closest('.ich-po__pill').hidden = !ok;
          inp.disabled = !ok;
        });
        let checked = inputs.find((inp) => inp.checked && !inp.disabled);
        if (!checked) {
          checked = inputs.find((inp) => !inp.disabled);
          if (checked) checked.checked = true;
        }
        sel[i] = checked ? checked.value : null;
        g.hidden = possible.size <= 1;
        const label = g.querySelector('[data-po-option-value]');
        if (label) label.textContent = sel[i] || '';
        // mark sold-out values for the current combination
        inputs.forEach((inp) => {
          const combo = sel.slice(); combo[i] = inp.value;
          const match = this.variants.find((v) => v.options.every((o, j) => j > i || o === combo[j]) && v.available);
          inp.closest('.ich-po__pill').classList.toggle('is-soldout', !match);
        });
      });

      const variant = this.variants.find((v) => v.options.every((o, i) => o === sel[i]));
      this.current = variant || null;
      if (variant) {
        this.idInput.value = variant.id;
        this.updatePrice(variant);
        if (changedIndex !== null) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
          if (variant.featured_media) this.showMedia(variant.featured_media.id);
        }
      }
      this.updateButton();
    }

    updatePrice(v) {
      const now = this.querySelector('[data-po-price-now]');
      const was = this.querySelector('[data-po-price-was]');
      now.textContent = this.money.format(v.price / 100);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        was.textContent = this.money.format(v.compare_at_price / 100);
        was.hidden = false;
      } else {
        was.hidden = true;
      }
      const barPrice = this.querySelector('[data-po-bar-price]');
      if (barPrice) barPrice.textContent = now.textContent;
    }

    updateButton() {
      const d = this.dataset;
      const open = this.isOpen();
      let label, disabled = false;
      if (!this.current) { label = d.labelUnavailable; disabled = true; }
      else if (!this.current.available) { label = d.labelSoldout; disabled = true; }
      else if (open) { label = d.labelOpen; }
      else if (d.afterEnd === 'normal') { label = d.labelNormal; }
      else { label = d.labelClosed; disabled = true; }

      this.submitLabel.textContent = label;
      this.submit.disabled = disabled;
      if (this.submitSub) this.submitSub.hidden = !open || disabled;
      if (this.property) this.property.disabled = !open;
      if (this.barBtn) { this.barBtn.textContent = label; this.barBtn.disabled = disabled; }
      const barNote = this.querySelector('[data-po-bar-note]');
      if (barNote) barNote.hidden = !open;
    }

    /* ---------- gallery: main image + thumbnails ---------- */
    initGallery() {
      this.slides = this.querySelector('[data-po-slides]');
      if (!this.slides) return;
      this.slideEls = [...this.slides.children];
      this.thumbs = [...this.querySelectorAll('[data-po-thumb]')];
      this.thumbWrap = this.querySelector('[data-po-thumbs]');
      this.navs = [...this.querySelectorAll('[data-po-nav]')];
      this.counter = this.querySelector('[data-po-index]');
      this.activeIndex = 0;

      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(parseInt(t.dataset.poThumb, 10))));
      this.navs.forEach((n) => n.addEventListener('click', () => this.goTo(this.activeIndex + parseInt(n.dataset.poNav, 10))));
      this.slides.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollRaf);
        this.scrollRaf = requestAnimationFrame(() => {
          this.setActive(Math.round(this.slides.scrollLeft / Math.max(1, this.slides.clientWidth)));
        });
      }, { passive: true });
      this.slides.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.goTo(this.activeIndex + 1);
        if (e.key === 'ArrowLeft') this.goTo(this.activeIndex - 1);
      });

      // keep the thumbnail column exactly as tall as the main image
      if ('ResizeObserver' in window && this.thumbWrap) {
        this.resizeObs = new ResizeObserver(() => {
          this.style.setProperty('--ich-po-main-h', this.slides.offsetHeight + 'px');
        });
        this.resizeObs.observe(this.slides);
      }
      this.setActive(0);
    }

    goTo(index) {
      if (!this.slideEls.length) return;
      const i = Math.max(0, Math.min(this.slideEls.length - 1, index));
      this.slides.scrollTo({ left: i * this.slides.clientWidth, behavior: 'smooth' });
      this.setActive(i);
    }

    setActive(i) {
      if (i === this.activeIndex && this.galleryReady) return;
      this.galleryReady = true;
      this.activeIndex = i;
      this.thumbs.forEach((t, j) => {
        const on = j === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      const t = this.thumbs[i];
      if (t && this.thumbWrap) {
        // scroll only the thumbnail strip, never the page
        const w = this.thumbWrap;
        if (w.scrollHeight > w.clientHeight) w.scrollTo({ top: t.offsetTop - w.clientHeight / 2 + t.offsetHeight / 2, behavior: 'smooth' });
        if (w.scrollWidth > w.clientWidth) w.scrollTo({ left: t.offsetLeft - w.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
      }
      if (this.counter) this.counter.textContent = i + 1;
      this.navs.forEach((n) => {
        const dir = parseInt(n.dataset.poNav, 10);
        n.disabled = dir < 0 ? i === 0 : i === this.slideEls.length - 1;
      });
    }

    showMedia(mediaId) {
      const slide = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (slide) this.goTo(parseInt(slide.dataset.index, 10));
    }

    /* ---------- sticky bar: show once the main button has scrolled away ---------- */
    initBar() {
      if (!this.bar || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.bar.classList.toggle('is-visible', show);
        this.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (this.barBtn) this.barBtn.tabIndex = show ? 0 : -1;
      });
      this.observer.observe(this.submit);
    }
  }
  customElements.define('ich-preorder', IchPreorder);
}
